<div class="bd_header">
    <div class="container-fluid">
        <app-header></app-header>
    </div>
</div>
<router-outlet></router-outlet>
<app-footer></app-footer>